import { NgModule } from '@angular/core';
import { SetImageUrlPipe } from './set-image-url.pipe';

@NgModule({
  declarations: [SetImageUrlPipe],
  exports: [SetImageUrlPipe],
})
export class SetImageUrlPipeModule {}
